import {RaVersion} from "../services/configuration/ra.version";
import {Injectable} from "@angular/core";
import {BootGlobals} from "../boot.globals";
import {Observable, throwError} from "rxjs";
import {Observer} from "rxjs";
import {BugsnagLoggingService} from "../services/logging/bugsnag-logging.service";
import {StartupHttpService} from "../services/http/startup.http.service";
import {ContentServerService} from "../services/configuration/content.server.service";
import {SessionStoragePersistenceStore} from "../services/persistence/session.storage.persistence.store";
import {share} from "rxjs/operators";
import {ErrorType} from "../constants";
import * as queryString from "query-string";
import {APIResult} from "../services/interaction/upload.service";

@Injectable()
export class AppConfigLoader {

    constructor(private httpService: StartupHttpService,
                private store: SessionStoragePersistenceStore,
                private loggingService: BugsnagLoggingService) {
                    ContentServerService.setSessionStorageStore(this.store);
                }

    private logContentServerFailedIfNeeded(): void {
        if (ContentServerService.isContentServerActive()) {
            let contentServerUrl = ContentServerService.determineContentServer();
            this.loggingService.error("Content server failed: " + contentServerUrl, ErrorType.CONTENT_SERVER);
        }
    }

    public loadAppConfig():Observable<boolean> {
        return new Observable((observer:Observer<boolean>) => {
            this.loadFromLocalPropertyFile().subscribe(() =>  {
                this.loadFromRemotePropertyFile().subscribe(() => {
                    observer.next(true);
                    observer.complete();
                })
            });
        })
    }

    public loadFromLocalPropertyFile(): Observable<boolean> {

        return new Observable((observer:Observer<boolean>) => {

            this.httpService.getJSONResponse("appconfig.json" + RaVersion.full,
                (data: APIResult) => {
                    ContentServerService.checkContentServerAvailable(this.httpService, () => {
                        let configData = data.data;
                        BootGlobals.config.addProps(configData);
                        this.logContentServerFailedIfNeeded();
                        observer.next(true);
                        observer.complete();
                    });
                },
                (error) => throwError(new Error("Unable to find local config file due to status: " + error.status))
            );
        });
    }

    public loadFromURL(): void {
        // only super user for now
        const {super_user} = queryString.parse(location.search);
        const {super_user_dev} = queryString.parse(location.search);
        const {content_tool_server_URL} = queryString.parse(location.search);
        BootGlobals.config.setSuperUserMode = super_user === "true" || super_user_dev === "true";
        if (super_user === "true" || super_user_dev === "true") {
            BootGlobals.config.setContentToolServerURL(content_tool_server_URL);
        }
        BootGlobals.config.setSuperUserDevMode = super_user_dev === "true";
    }

    public loadFromRemotePropertyFile(): Observable<boolean> {

        return new Observable((observer: Observer<boolean>) => {

            if (BootGlobals.config.isSuperUserMode) {
                observer.next(true);
                observer.complete();
            }
            if (!BootGlobals.config.isSuperUserMode) {
                this.httpService.getJSONResponseWithReferrer(BootGlobals.config.propsPath + RaVersion.full,
                    (data) => {
                        let configData = data.data;
                        BootGlobals.config.addProps(configData);
                        observer.next(true);
                        observer.complete();
                    },
                    (error) => {
                      throwError(new Error("Unable to find remote config file due to status: " + error.status));
                    }
                );
            }
        });
    }
}
